var crRating = (function() {
	return {

		init: function(element) {
      var circles = element ? element.querySelectorAll('.rating-circle') : document.querySelectorAll('.rating-circle');
      for (var i = 0; i < circles.length; i++) {
        var circle = circles[i].querySelector('circle');
        var score = parseInt(circles[i].getAttribute('data-score'), 10);
        var max = parseInt(circles[i].getAttribute('data-max'), 10);
        var scale = parseInt(circles[i].getAttribute('data-scale'), 10);
        var offset = parseInt(circles[i].getAttribute('data-offset'), 10);

        var scoreFloat = score/max;
        if (scoreFloat < 0.20) {
          scoreFloat = 0.20;
        }

        var scoreCss = offset + Math.round(score/max * scale);
        circle.style['stroke-dasharray'] = scoreCss;
      }
		}
	};
})();
